import { render } from "./AppLoader.vue?vue&type=template&id=165bac5d&scoped=true"
import script from "./AppLoader.vue?vue&type=script&lang=ts"
export * from "./AppLoader.vue?vue&type=script&lang=ts"

import "./AppLoader.vue?vue&type=style&index=0&id=165bac5d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-165bac5d"

export default script